<!-- SwipFx Orders Page (Bootstrap 5) -->
<!-- Tabs need bootstrap.bundle.js -->
<div class="min-vh-100 bg-light">
  <app-header [page]="'Admin'"></app-header>
  <main class="container py-4">

    <div class="d-flex justify-content-between align-items-center mb-3">
      <div>
        <h4 class="fw-bold mb-0">Policy Rules</h4>
        <div class="text-muted small">
          Configure workflow, validation and compliance rules for this policy
        </div>
      </div>

      <div class="d-flex gap-2">

        <button class="btn btn-outline-primary btn-sm" type="button" (click)="openFields()">
          Manage Fields
        </button>

        <button class="btn btn-outline-primary btn-sm" type="button" (click)="openDocuments()">
          Manage Documents
        </button>

        <button class="btn btn-outline-secondary btn-sm" (click)="back()">
          Back to Policy
        </button>
      </div>
    </div>

    <div class="card shadow-sm border-0 mb-4" *ngIf="policy">
      <div class="card-body">
        <div class="row g-3 small">
          <div class="col-md-4">
            <div class="text-muted">Policy</div>
            <div class="fw-semibold">{{ policy.name }}</div>
          </div>
          <div class="col-md-2">
            <div class="text-muted">Tier</div>
            <div class="fw-semibold">{{ policy.tierCode }}</div>
          </div>
          <div class="col-md-3">
            <div class="text-muted">Jurisdiction</div>
            <div class="fw-semibold">{{ policy.jurisdictionName }}</div>
          </div>
          <div class="col-md-3">
            <div class="text-muted">Version</div>
            <div class="fw-semibold">{{ policy.version }}</div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="loading" class="text-center py-4">
      <div class="spinner-border"></div>
    </div>

    <div *ngIf="error" class="alert alert-danger">
      {{ error }}
    </div>

    <form [formGroup]="importForm" (ngSubmit)="importRules()" class="card shadow-sm border-0 mb-4">
      <div class="card-body">
        <div class="d-flex justify-content-between align-items-start gap-3 flex-wrap mb-3">
          <div>
            <h5 class="mb-1">Import Rules</h5>
            <div class="text-muted small">
              Copy rules from another jurisdiction, tier, or policy into this policy.
            </div>
          </div>
        </div>

        <div class="row g-3 align-items-end">
          <div class="col-md-7">
            <label class="form-label">Source Policy</label>
            <select class="form-select" formControlName="sourcePolicyId">
              <option value="">Select source policy</option>
              <option *ngFor="let item of availableImportPolicies" [value]="item.id">
                {{ item.jurisdictionName || item.jurisdictionCode || item.jurisdictionId }} -
                {{ item.tierCode }} -
                {{ item.name }} v{{ item.version }}
              </option>
            </select>
            <div class="small text-danger mt-1" *ngIf="sourcePolicyId?.touched && sourcePolicyId?.invalid">
              Source policy is required.
            </div>
          </div>

          <div class="col-md-3">
            <label class="form-label d-block">Existing Rules</label>
            <div class="form-check form-switch mt-2">
              <input class="form-check-input" type="checkbox" formControlName="overwriteExisting" />
              <label class="form-check-label">Overwrite matching rule codes</label>
            </div>
          </div>

          <div class="col-md-2">
            <button class="btn btn-outline-primary w-100" type="submit" [disabled]="importing">
              <span *ngIf="importing" class="spinner-border spinner-border-sm me-2"></span>
              Import
            </button>
          </div>
        </div>
      </div>
    </form>

    <form [formGroup]="form" (ngSubmit)="save()" class="card shadow-sm border-0 mb-4">
      <div class="card-body">
        <h5 class="mb-3">{{ editingId ? 'Edit Rule' : 'New Rule' }}</h5>

        <div class="row g-3">
          <div class="col-md-4">
            <label class="form-label">Rule Code</label>
            <select class="form-select" formControlName="ruleCode">

              <option value="">
                Select rule code
              </option>

              <option *ngFor="let code of ruleCodeOptions" [value]="code">
                {{ code }}
              </option>

            </select>
            <div class="small text-danger mt-1" *ngIf="ruleCode && ruleCode.touched && ruleCode.invalid">
              Rule code is required.
            </div>
          </div>

          <div class="col-md-3">
            <label class="form-label">Rule Type</label>
            <select class="form-select" formControlName="ruleType">
              <option *ngFor="let item of ruleTypes" [value]="item">{{ item }}</option>
            </select>
          </div>

          <div class="col-md-2">
            <label class="form-label">Order Index</label>
            <input class="form-control" type="number" min="0" formControlName="orderIndex" />
          </div>

          <div class="col-md-3">
            <label class="form-label d-block">Blocking</label>
            <div class="form-check form-switch mt-2">
              <input class="form-check-input" type="checkbox" formControlName="isBlocking" />
              <label class="form-check-label">Yes</label>
            </div>
          </div>

          <div class="col-md-12" *ngIf="isRuleType('RequiredFields')">
            <label class="form-label">Required Fields</label>

            <select multiple class="form-select" formControlName="requiredFieldKeys">
              <option *ngFor="let field of availableFields" [value]="field.fieldKey">
                {{ field.label || field.fieldKey }} — {{ field.fieldKey }}
              </option>
            </select>

            <div class="form-text">
              Select all KYC fields that must be completed before submission.
            </div>
          </div>

          <div class="col-md-12" *ngIf="isRuleType('RequiredDocuments')">
            <label class="form-label">Required Documents</label>

            <select multiple class="form-select" formControlName="requiredDocumentTypeCodes">
              <option *ngFor="let document of availableDocuments" [value]="document.documentTypeCode">
                {{ document.label || document.documentTypeCode }} — {{ document.documentTypeCode }}
              </option>
            </select>

            <div class="form-text">
              Select all documents that must be uploaded before submission.
            </div>
          </div>

          <div class="col-md-6" *ngIf="isRuleType('MinimumAge')">
            <label class="form-label">Date of Birth Field</label>

            <select class="form-select" formControlName="minimumAgeFieldKey">
              <option value="date_of_birth">date_of_birth</option>
              <option *ngFor="let field of availableFields" [value]="field.fieldKey">
                {{ field.label || field.fieldKey }} — {{ field.fieldKey }}
              </option>
            </select>
          </div>

          <div class="col-md-3" *ngIf="isRuleType('MinimumAge')">
            <label class="form-label">Minimum Age</label>
            <input class="form-control" type="number" min="1" formControlName="minimumAge" />
          </div>

          <div class="col-md-12" *ngIf="isRuleType('DocumentNotExpired')">
            <label class="form-label">Documents That Must Not Be Expired</label>

            <select multiple class="form-select" formControlName="documentNotExpiredTypeCodes">
              <option *ngFor="let document of availableDocuments" [value]="document.documentTypeCode">
                {{ document.label || document.documentTypeCode }} — {{ document.documentTypeCode }}
              </option>
            </select>

            <div class="form-text">
              Usually this should include government ID documents that require an expiry date.
            </div>
          </div>

          <div class="col-md-6" *ngIf="isRuleType('SelfieMatch')">
            <label class="form-label">ID Document</label>

            <select class="form-select" formControlName="selfieIdDocumentTypeCode">
              <option value="">Select ID document</option>
              <option *ngFor="let document of availableDocuments" [value]="document.documentTypeCode">
                {{ document.label || document.documentTypeCode }} — {{ document.documentTypeCode }}
              </option>
            </select>
          </div>

          <div class="col-md-6" *ngIf="isRuleType('SelfieMatch')">
            <label class="form-label">Selfie Document</label>

            <select class="form-select" formControlName="selfieDocumentTypeCode">
              <option value="SELFIE">SELFIE</option>
              <option *ngFor="let document of availableDocuments" [value]="document.documentTypeCode">
                {{ document.label || document.documentTypeCode }} — {{ document.documentTypeCode }}
              </option>
            </select>
          </div>

          <div class="col-md-6" *ngIf="isRuleType('SanctionsScreening')">
            <label class="form-label">ID Document For Screening</label>

            <select class="form-select" formControlName="sanctionsIdDocumentTypeCode">
              <option value="">Select ID document</option>
              <option *ngFor="let document of availableDocuments" [value]="document.documentTypeCode">
                {{ document.label || document.documentTypeCode }} — {{ document.documentTypeCode }}
              </option>
            </select>
          </div>

          <div class="col-md-12" *ngIf="
    !isRuleType('RequiredFields') &&
    !isRuleType('RequiredDocuments') &&
    !isRuleType('MinimumAge') &&
    !isRuleType('DocumentNotExpired') &&
    !isRuleType('SelfieMatch') &&
    !isRuleType('SanctionsScreening')
  ">
            <label class="form-label">Config JSON</label>
            <textarea class="form-control" rows="4" formControlName="configJson"
              placeholder='{"key":"value"}'></textarea>

            <div class="form-text">
              Advanced rule types can still use raw JSON.
            </div>
          </div>
        </div>

        <div class="mt-4 d-flex gap-2">
          <button class="btn btn-primary" type="submit" [disabled]="saving">
            <span *ngIf="saving" class="spinner-border spinner-border-sm me-2"></span>
            {{ editingId ? 'Update Rule' : 'Create Rule' }}
          </button>

          <button class="btn btn-outline-secondary" type="button" (click)="resetForm()">
            Clear
          </button>
        </div>
      </div>
    </form>

    <div *ngIf="!loading && !items.length" class="alert alert-light border">
      No policy rules found.
    </div>

    <div *ngIf="items.length" class="card shadow-sm border-0">
      <div class="table-responsive">
        <table class="table table-hover align-middle mb-0">
          <thead class="table-light">
            <tr>
              <th>Code</th>
              <th>Type</th>
              <th>Blocking</th>
              <th>Order</th>
              <th>Config</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let item of items">
              <td class="fw-semibold">{{ item.ruleCode }}</td>
              <td>{{ item.ruleType }}</td>
              <td>{{ item.isBlocking ? 'Yes' : 'No' }}</td>
              <td>{{ item.orderIndex }}</td>
              <td>
                <small class="text-muted">{{ item.configJson || '-' }}</small>
              </td>
              <td class="text-end">
                <div class="d-inline-flex gap-2">
                  <button class="btn btn-sm btn-outline-primary" (click)="edit(item)">Edit</button>
                  <button class="btn btn-sm btn-outline-danger" [disabled]="deletingId === item.id"
                    data-bs-toggle="modal"
                    data-bs-target="#deletePolicyRuleModal"
                    (click)="openDeleteModal(item)">
                    <span *ngIf="deletingId === item.id" class="spinner-border spinner-border-sm me-2"></span>
                    Delete
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <app-footer></app-footer>
  </main>
</div>

<div class="modal fade" id="deletePolicyRuleModal" tabindex="-1" aria-labelledby="deletePolicyRuleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content border-0 shadow">
      <div class="modal-header">
        <h5 class="modal-title fw-semibold" id="deletePolicyRuleModalLabel">Delete Policy Rule</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          [disabled]="!!deletingId"></button>
      </div>

      <div class="modal-body">
        <div class="alert alert-warning py-2">
          This will remove the rule from this policy.
        </div>

        <div *ngIf="rulePendingDelete" class="border rounded p-3 bg-light-subtle">
          <div class="fw-semibold">{{ rulePendingDelete.ruleCode }}</div>
          <div class="text-muted small">{{ rulePendingDelete.ruleType }}</div>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal"
          [disabled]="!!deletingId">
          Cancel
        </button>

        <button type="button" class="btn btn-danger" (click)="confirmDelete()"
          [disabled]="!!deletingId || !rulePendingDelete">
          <span *ngIf="!!deletingId" class="spinner-border spinner-border-sm me-2"></span>
          Delete Rule
        </button>
      </div>
    </div>
  </div>
</div>
